import * as React from "react";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { store } from "../../../../../store";
import { CpInput } from "../../../../gvc/testNewForm/CpInput";
import { CpSelect } from "../../../../gvc/testNewForm/CpSelect";
import { FormListFieldItem } from "../../../../gvc/formListFieldItem";
import { formSet, formSetValue, formTriggerValidation } from "../../../../gvc/testNewForm/utils";
import { TaintInput } from "../../../../../schema/types/mk8s/input/common";
import { useCpFormContext } from "../../../../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: TaintInput;
  index?: number;
}
export const CpArrayItemTaint: React.FC<Props> = React.memo(({ name: _name, item: _item, index: _index }) => {
  const { id } = useCpFormContext();
  const name = _name!;
  const item = _item!;
  const index = _index!;

  function remove() {
    const form = store.getState().form.instances[id];
    const values = form.values;
    const items = get(values, name) || [];
    let _items = cloneDeep(items);
    _items = _items.filter((i) => i.id !== item.id);
    formSetValue(id, name, _items);

    formTriggerValidation(id);
  }

  return (
    <FormListFieldItem columnCount={3} hasRemoveButton className="mb-1">
      <CpInput name={`${name}.${index}.key`} className={`col-span-1`} />
      <CpInput name={`${name}.${index}.value`} className={`col-span-1`} />
      <CpSelect
        name={`${name}.${index}.effect`}
        className={`col-span-1`}
        options={[
          { label: "NoSchedule", value: "NoSchedule" },
          { label: "PreferNoSchedule", value: "PreferNoSchedule" },
          { label: "NoExecute", value: "NoExecute" },
        ]}
      />
      <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
    </FormListFieldItem>
  );
});
